import React from 'react';
import './River5India.css';

const SlideRiver = ({ image, text, readText }) => {
  return (
    <div className="slide">
      <img src={`./images/${image}`} alt="Slide" />
      <p>{text}</p>
      <button onClick={() => readText(text)} className="start-button">
        Start Slide
      </button>
    </div>
  );
};

export default SlideRiver;